var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fold',{staticClass:"newsletter-fold",on:{"click":_vm.loadAnsShowPopup}},[_vm._v("\n    Castorama newsletter - zapisz się\n")])}
var staticRenderFns = []

export { render, staticRenderFns }